<template>
  <div id="application-page" class="main-page">
    <vue-headful title="High Risk Merchant Application | Gunspring" />
    <div class="gs-breadcrumbs">
      <div class="container">
        <span>
          <a href="#" class="gs-breadcrumb">home</a>
        </span>
        <span>
          <i class="fas fa-chevron-right gs-breadcrumb-arrow"></i>
        </span>
        <span class="gs-breadcrumb-active">application</span>
      </div>
    </div>
    <div v-if="reg">
      <div class="container">
        <div class="page-hero">
          <p class="page-hero-title">Let's Get Started!</p>
          <p class="page-hero-text">This information helps us better serve you.</p>
        </div>
      </div>

      <div class="application-page-1">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 text-center">
              <i class="fas fa-3x fa-rocket get-started-icon"></i>
              <p class="gs-title-sm">Keep It Simple</p>
              <p class="gs-text-sm">
                Give your business the lift it needs. Together, we'll guide you
                through step-by-step.
              </p>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 text-center">
              <i class="fas fa-3x fa-handshake get-started-icon"></i>
              <p class="gs-title-sm">A Few Quick Steps</p>
              <p class="gs-text-sm">
                Get approved quickly and easily, so you enhance your business
                with us.
              </p>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 text-center">
              <i class="fas fa-3x fa-paper-plane get-started-icon"></i>
              <p class="gs-title-sm">Advanced Features</p>
              <p class="gs-text-sm">
                Our payment gateway includes 3D Secure, multi-currency
                conversion, and intelligent transaction routing.
              </p>
            </div>
          </div>

          <div class="application-form-section">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                <countryInputBase
                  v-model.number="selected_country"
                  :nameclass="{
                    'error register-dropdown': $v.selected_country.$error,
                    'register-dropdown': !$v.selected_country.$error,
                  }"
                  label="Where is your business located?"
                />

                <industryInputBase
                  v-model.number="selected_industry"
                  :nameclass="{
                    'error register-dropdown': $v.selected_industry.$error,
                    'register-dropdown': !$v.selected_industry.$error,
                  }"
                  label="What is your Industry?"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                <apptypeInputBase
                  v-model="selected_app"
                  :nameclass="{
                    'error register-dropdown': $v.selected_app.$error,
                    'register-dropdown': !$v.selected_app.$error,
                  }"
                  label="What Services are you interested in?"
                />

                <textInputBase
                  placeholder="http://example.com"
                  v-model="url"
                  label="What's your URL"
                  :nameclass="{
                    'error register-input': $v.url.$error,
                    'register-input': !$v.url.$error,
                  }"
                  :type="'url'"
                />
              </div>
            </div>

            <div class="application-continue text-center">
              <button class="application-continue-btn" @click="onNext()">
                Continue
                <i class="fas fa-long-arrow-alt-right"></i>
              </button>
              <p class="application-continue-text">
                Already have an account?
                <span>
                  <router-link class="application-continue-link" :to="{ name: 'login' }">Sign in</router-link>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="application-page-2">
        <div class="container">
          <div class="page-hero">
            <p class="page-hero-title">Let's Create your Account</p>
            <p class="page-hero-text">
              Signing up is quick, and easy. Just a few basic questions to
              start.
            </p>
          </div>
          <div class="application-form-section">
            <div class="row">
              <div
                class="col-xl-6 col-lg-6 col-md-5 col-sm-12 order-md-last col-application-page-2-extra"
              >
                <div class="row row-create-account-section">
                  <div class="col-xl-2 col-lg-2 col-md-3 col-sm-2 col-2 text-center">
                    <i class="fas fa-fw fa-3x fa-users"></i>
                  </div>
                  <div class="col-xl-10 col-lg-10 col-md-9 col-sm-10 col-10">
                    <p class="create-account-title">All Businesses Are Welcome</p>
                    <p class="create-account-text">
                      Whether you work in an industry that has reputational
                      risk, you're new to accepting payments, or if you have no
                      credit, we work to find a solution that's right for you.
                    </p>
                  </div>
                </div>

                <div class="row row-create-account-section">
                  <div class="col-xl-2 col-lg-2 col-md-3 col-sm-2 col-2 text-center">
                    <i class="fas fa-fw fa-3x fa-clipboard-check"></i>
                  </div>
                  <div class="col-xl-10 col-lg-10 col-md-9 col-sm-10 col-10">
                    <p class="create-account-title">Quick Merchant Account Approvals</p>
                    <p class="create-account-text">
                      After completing the simple online application a
                      representative will get back to you within 1 business day.
                    </p>
                  </div>
                </div>

                <div class="row row-create-account-section">
                  <div class="col-xl-2 col-lg-2 col-md-3 col-sm-2 col-2 text-center">
                    <i class="fas fa-fw fa-3x fa-address-card"></i>
                  </div>
                  <div class="col-xl-10 col-lg-10 col-md-9 col-sm-10 col-10">
                    <p class="create-account-title">Real Time Account Status</p>
                    <p class="create-account-text">
                      Sign up now and view the real time status of your
                      application. Connect with us at anytime if you have
                      questions.
                    </p>
                  </div>
                </div>
              </div>

              <div
                class="col-xl-6 col-lg-6 col-md-7 col-sm-12 order-md-first col-application-page-2-form"
              >
                <textInputBase
                  v-model="name"
                  label="Name"
                  ref="nameInput"
                  :nameclass="{
                    'error register-input': $v.name.$error,
                    'register-input': !$v.name.$error,
                  }"
                  @keyup="nameValidation"
                  :err="errname"
                  :type="'name'"
                />
                
                <emailInputBase
                  v-model="user_email"
                  label="Email"
                  :nameclass="{
                    'error register-input': $v.user_email.$error,
                    'register-input': !$v.user_email.$error,
                  }"
                  @validateEmail="
                    (a) => {
                      isValidEmail = a;
                    }
                  "
                />
                <phonecodeInputBase
                  v-model.number="selected_country_dial"
                  :nameclass="{
                    'error register-dropdown': $v.selected_country_dial.$error,
                    'register-dropdown': !$v.selected_country_dial.$error,
                  }"
                  label="Country Telephone Code"
                />
                <phoneInputBase
                  v-model="phone"
                  label="Phone"
                  :nameclass="{
                    'error register-input': $v.phone.$error,
                    'register-input': !$v.phone.$error,
                  }"
                />
                <passwordInputBase
                  v-model="password"
                  label="Password"
                  :msg="msgs"
                  :nameclass="{
                    'error register-input': $v.password.$error,
                    'register-input': !$v.password.$error,
                  }"
                  @validatePassword="
                    (a) => {
                      isValidPassword = a;
                    }
                  "
                />

                <div class="application-continue text-center">
                  <div v-if="loading" class="form-btn-section text-center">
                    <!-- <i  class="fas fa-spinner fa-pulse"></i> Loading...</p> -->
                    <button disabled class="blue-cta login-btn" type="submit"><i class="fa fa-spinner fa-pulse fa fa-fw"></i> Registering</button>
                  </div>
                  <div v-else>
                    <button class="application-continue-btn" @click="onPrev()">
                      <i class="fas fa-long-arrow-alt-left"></i> Back
                    </button>
                    <button class="application-continue-btn" @click="onRegister()">
                      Register
                      <i class="fas fa-long-arrow-alt-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  textInputBase,
  countryInputBase,
  industryInputBase,
  apptypeInputBase,
  emailInputBase,
  passwordInputBase,
  phonecodeInputBase,
  phoneInputBase
} from "../components/forms/baseForms";

import Vue from "vue";
import axios from "axios";
import Vuelidate from "vuelidate";
import { required, minLength, url, email } from "vuelidate/lib/validators";
Vue.use(Vuelidate);
const validateName = (value) => (
  value.trim().indexOf(' ') != -1
);
const validateUrl = (value) => {
  // return value.match(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi) != null
  if (!value) return true
  return value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi) != null
}
export default {
  components: {
    textInputBase,
    countryInputBase,
    industryInputBase,
    apptypeInputBase,
    emailInputBase,
    passwordInputBase,
    phonecodeInputBase,
    phoneInputBase
  },
  name: "Register",
  props: {
    msg: String
  },
  data: () => ({
    errname:false,
    errors: [{ submitStatus: null }],
    name: "",
    selected_country: 234, //default for US
    selected_industry: 58, //default for firearms
    selected_country_dial: null,
    selected_app: "",
    user_email: "",
    isValidEmail: false,
    password: "",
    isValidPassword: false,
    phone: null,
    reg: true,
    url: null,
    msgs: null,
    loading: false,
  }),
  validations: {
    selected_app: {
      required,
      minLength: minLength(2)
    },
    selected_industry: {
      required
    },
    selected_country: {
      required
    },
    url: {
      required,
      validateUrl
    },
    validationGroup1: [
      "selected_app",
      "selected_industry",
      "selected_country",
      "url"
    ],
    name: {
      required,
      minLength: minLength(5),
      validateName
    },
    phone: {
      required
    },
    user_email: {
      required,
      minLength: minLength(5),
      email
    },
    password: {
      required,
      minLength: minLength(6)
    },
    selected_country_dial: {
      required
    },

    validationGroup2: [
      "name",
      "phone",
      "user_email",
      "password",
      "selected_country_dial"
    ]
  },
  methods: {
    nameValidation(){
      if(this.name != ""){
      this.errname = !this.$v.name.validateName
      }
    },
    onNext: function() {
      this.$v.validationGroup1.$touch();
      if (this.$v.validationGroup1.$invalid) {
        this.errors.submitStatus = "error";
      } else {
        this.reg = false;
        window.scrollTo(0, 0);
      }
    },
    onPrev: function() {
      this.reg = true;
      window.scrollTo(0, 0);
    },
    onRegister: async function() {
      this.$v.validationGroup2.$touch();
      if (this.$v.validationGroup2.$invalid) {
        this.errors.submitStatus = "error";
      } else {
        var data = {
          name: this.name,
          email: this.user_email,
          located_business: this.selected_country,
          country_dial: this.selected_country_dial,
          industry_type: this.selected_industry,
          app: this.selected_app,
          url: this.url,
          phone: this.phone,
          password: this.password
        };
        this.loading = true;
        axios
          .post("applications/register/", (data = data))
          .then(resp => {
            if (resp.status === 201) {
              this.$store
                .dispatch("verifyToken", { token: resp.data.token })
                .then(() => {
                  if (this.$store.state.baseApp == "MP") {
                    this.$router.push({ name: "merchant" });
                    this.$router.go;
                  } else if (this.$store.state.baseApp == "EC") {
                    this.$router.push({ name: "echeck" });
                    this.$router.go;
                  } else if (this.$store.state.baseApp == "CS") {
                    this.$router.push({ name: "chargeback" });
                    this.$router.go;
                  } else if (this.$store.state.baseApp == "CR") {
                    this.$router.push({ name: "crypto" });
                    this.$router.go;
                  } else {
                    this.$router.push({ name: "sorry" });
                  }
                  this.loading = false;
                })
                .catch(err => {
                  // console.log(err);
                  this.loading = false;
                  if (err.response.status == 400) {
                    this.$router.push({
                      name: "login",
                      query: { message: "verify" }
                    });
                  }
                });
            } else {
              // console.log(resp);
              this.loading = false;
            }
          })
          .catch(err => {
            if (err.response.status === 302) {
              this.$router.push({ name: "login" });
            }
            if (err.response.status === 400) {
              this.msgs = err.response.data.password[0];
            }
            this.loading = false;
          });
      }
    }
  },

  mounted: () => {},
  watch: {
    password: function(update, old) {
      if (update == "") {
        this.msgs = null;
      }},
      name: function(update, old) {
       if (update==""){
         this.errname =false
       }
    }
  }
};
</script>

<style>
.error select {
  border-color: red;
  background: #fdd;
}
.error input {
  border-color: red;
  background: #fdd;
}

.error:focus {
  outline-color: #f99;
}

/* Application Page 2 */
.col-application-page-2-form {
  padding-right: 50px !important;
  border-right: 1px solid #e6e6e6;
}

.col-application-page-2-extra {
  padding-left: 50px !important;
}

.row-create-account-section {
  margin-bottom: 75px;
}

.row-create-account-section i {
  color: #673ab7;
}

.create-account-title {
  font-size: 18px;
  margin: 0 0 10px 0;
}

.create-account-text {
  font-size: 16px;
  margin: 0;
  font-weight: 300;
  color: #778593;
}

.application-page-2
  .application-continue
  .application-continue-btn:first-of-type {
  margin-right: 15px;
}

@media (max-width: 767.98px) {
  .col-application-page-2-form {
    padding-right: 15px !important;
    border-right: 0;
  }

  .col-application-page-2-extra {
    padding-left: 15px !important;
  }
}
</style>
